import * as types from './mutation-types'

export const mutations = {
  [types.CHECKIN_LOADING](state) {
    state.current.loading = true
    state.current.data = null
    state.current.error = false
  },
  [types.CHECKIN_ERROR](state, error) {
    state.current.loading = false
    state.current.data = null
    state.current.error = error
  },
  [types.CHECKIN_COMPLETE](state, payload) {
    state.current.loading = false
    state.current.data = payload
    state.current.error = false
  }
}



//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/checkin/mutations.js
// module id = null
// module chunks = 